import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BarGraph from "../../../general/BarGraph";
import BigCard from "../../../general/BigCard";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./HealthL2.module.css";
import HealthMap from "./maps/HealthMap";
import { HealthStore } from "./HealthStore";

function HealthL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [usoMedicamento, setUsoMedicamento] = useState(null);
  const [dificuldadeAtendimento, setDificuldadeAtendimento] = useState(null);
  const [qualidadeSSMunicipal, setQualidadeSSMunicipal] = useState(null);
  const [qualidadeSSRural, setQualidadeSSRural] = useState(null);
  const [usoMedicamentoOldValue, setUsoMedicamentoOldValue] = useState(null);
  const [dificuldadeAtendimentoOldValue, setDificuldadeAtendimentoOldValue] =
    useState(null);

  const setUsoMedicamentoValue = HealthStore(
    (state) => state.setUsoMedicamentoValue
  );

  const setDificuldadeAtendimentoValue = HealthStore(
    (state) => state.setDificuldadeAtendimentoValue
  );

  const setHealthMapImage = HealthStore((state) => state.setHealthMapImage);

  const setUsoMedicamentoImage = HealthStore(
    (state) => state.setUsoMedicamentoImage
  );

  const setDificuldadeAtendimentoImage = HealthStore(
    (state) => state.setDificuldadeAtendimentoImage
  );

  const setQualidadeSSMunicipalImage = HealthStore(
    (state) => state.setQualidadeSSMunicipalImage
  );

  const setQualidadeSSRuralImage = HealthStore(
    (state) => state.setQualidadeSSRuralImage
  );

  const frequenciaExameValue = HealthStore(
    (state) => state.frequenciaExameValue
  );

  const atendimentoAmbulanciaValue = HealthStore(
    (state) => state.atendimentoAmbulanciaValue
  );

  const sistemaSaudeValue = HealthStore((state) => state.sistemaSaudeValue);

  const usoMedicamentoValue = HealthStore((state) => state.usoMedicamentoValue);

  const dificuldadeAtendimentoValue = HealthStore(
    (state) => state.dificuldadeAtendimentoValue
  );

  const possuiDoencaCronicaValue = HealthStore(
    (state) => state.possuiDoencaCronicaValue
  );

  const tipoDoencaCronicaValue = HealthStore(
    (state) => state.tipoDoencaCronicaValue
  );

  const programaSaudeRuralValue = HealthStore(
    (state) => state.programaSaudeRuralValue
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          usoMedicamento,
          dificuldadeAtendimento,
          qualidadeSSMunicipal,
          qualidadeSSRural,
          numeroPropriedades,
        ] = await Promise.all([
          Api.getUsoMedicamento(
            distrito,
            frequenciaExameValue,
            atendimentoAmbulanciaValue,
            sistemaSaudeValue,
            null,
            dificuldadeAtendimentoValue,
            possuiDoencaCronicaValue,
            tipoDoencaCronicaValue,
            programaSaudeRuralValue
          ),
          Api.getDificuldadeAtendimento(
            distrito,
            frequenciaExameValue,
            atendimentoAmbulanciaValue,
            sistemaSaudeValue,
            usoMedicamentoValue,
            null,
            possuiDoencaCronicaValue,
            tipoDoencaCronicaValue,
            programaSaudeRuralValue
          ),
          Api.getQualidadeSSMunicipal(
            distrito,
            frequenciaExameValue,
            atendimentoAmbulanciaValue,
            sistemaSaudeValue,
            usoMedicamentoValue,
            dificuldadeAtendimentoValue,
            possuiDoencaCronicaValue,
            tipoDoencaCronicaValue,
            programaSaudeRuralValue
          ),
          Api.getQualidadeSSRural(
            distrito,
            frequenciaExameValue,
            atendimentoAmbulanciaValue,
            sistemaSaudeValue,
            usoMedicamentoValue,
            dificuldadeAtendimentoValue,
            possuiDoencaCronicaValue,
            tipoDoencaCronicaValue,
            programaSaudeRuralValue
          ),
          Api.getNumeroPropriedadesSaude(
            distrito,
            frequenciaExameValue,
            atendimentoAmbulanciaValue,
            sistemaSaudeValue,
            usoMedicamentoValue,
            dificuldadeAtendimentoValue,
            possuiDoencaCronicaValue,
            tipoDoencaCronicaValue,
            programaSaudeRuralValue
          ),
        ]);

        setUsoMedicamento(Functions.buildSmallPieGraphParams(usoMedicamento));
        setDificuldadeAtendimento(
          Functions.buildSmallPieGraphParams(dificuldadeAtendimento)
        );
        setQualidadeSSMunicipal(Functions.buildBarGraph(qualidadeSSMunicipal));
        setQualidadeSSRural(Functions.buildBarGraph(qualidadeSSRural));
        setNumeroPropriedades(numeroPropriedades);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    frequenciaExameValue,
    atendimentoAmbulanciaValue,
    sistemaSaudeValue,
    usoMedicamentoValue,
    dificuldadeAtendimentoValue,
    possuiDoencaCronicaValue,
    tipoDoencaCronicaValue,
    programaSaudeRuralValue,
  ]);

  const onUsoMedicamentoOldValue = (value) => {
    setUsoMedicamentoOldValue(value);
  };

  const onDificuldadeAtendimentoOldValue = (value) => {
    setDificuldadeAtendimentoOldValue(value);
  };

  const onUsoMedicamentoClick = (value) => {
    setUsoMedicamentoValue(value);
  };

  const onDificuldadeAtendimentoClick = (value) => {
    setDificuldadeAtendimentoValue(value);
  };

  return (
    <div className={styles.healthL2}>
      <div className={styles.firstPart}>
        <div className={styles.mapCards}>
          <div className={styles.cards}>
            <div className={styles.bigCard}>
              <BigCard
                name="Propriedades"
                value={numeroPropriedades?.value ?? "..."}
              />
            </div>
          </div>

          <div className={styles.map}>
            <HealthMap distrito={distrito} onImageReady={setHealthMapImage} />
          </div>
        </div>
        <div className={styles.healthGraphs}>
          {usoMedicamento && (
            <div className={styles.smallPiegraph}>
              <SmallPieGraph
                data={usoMedicamento}
                text="USO DE MEDICAMENTOS"
                onLegendClick={onUsoMedicamentoClick}
                currentValue={usoMedicamentoValue}
                oldValue={usoMedicamentoOldValue}
                onOldValue={onUsoMedicamentoOldValue}
                onImageReady={setUsoMedicamentoImage}
              />
            </div>
          )}
          {dificuldadeAtendimento && (
            <div className={styles.smallPiegraph}>
              <SmallPieGraph
                data={dificuldadeAtendimento}
                text="DIFICULDADE DE ATENDIMENTO"
                onLegendClick={onDificuldadeAtendimentoClick}
                currentValue={dificuldadeAtendimentoValue}
                oldValue={dificuldadeAtendimentoOldValue}
                onOldValue={onDificuldadeAtendimentoOldValue}
                onImageReady={setDificuldadeAtendimentoImage}
              />
            </div>
          )}
        </div>
      </div>

      <div className={styles.barGraph}>
        {qualidadeSSMunicipal && (
          <div className={styles.graph}>
            <BarGraph
              data={qualidadeSSMunicipal}
              text="QUALIDADE DO SISTEMA DE SAÚDE MUNICIPAL"
              onImageReady={setQualidadeSSMunicipalImage}
            />
          </div>
        )}
        {qualidadeSSRural && (
          <div className={styles.graph}>
            <BarGraph
              data={qualidadeSSRural}
              text="QUALIDADE DO SISTEMA DE SAÚDE RURAL"
              onImageReady={setQualidadeSSRuralImage}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default HealthL2;
